// The one predicate every revision-scoped Hasura read builds on. Project child tables
// carry a revision_id, so:
//  - reading a FROZEN revision (a preview pin) filters on its id;
//  - reading the WORKING STATE filters on "the unfrozen revision" — deliberately not on an id, so
//    it is correct before the revision list has loaded and can never mix two revisions' rows.
//
// Writes never pass this: inserts are stamped server-side by the BEFORE INSERT trigger, and
// update/delete permissions only match the unfrozen revision's rows.

export interface RevisionScopeFilter {
  revisionId?: { _eq: string };
  revision?: { frozenAt: { _is_null: boolean } };
}

export const revisionScopeFilter = (pinnedRevisionId?: string | null): RevisionScopeFilter =>
  pinnedRevisionId ? { revisionId: { _eq: pinnedRevisionId } } : { revision: { frozenAt: { _is_null: true } } };

/** The working state's filter — what every cache read/write of a live list must key on. */
export const workingRevisionFilter = (): RevisionScopeFilter => revisionScopeFilter(null);
